module.exports = __webpack_public_path__ + "static/NeueMontreal-Light-96c44249b8b2ada0f3a86a25c0339593.woff2";